import CandidateInfoForm from "pages/ManagementPage/candidateInfoForm/CandidateInfoForm/CandidateInfoForm";

export default CandidateInfoForm;
